/** Best-effort overwrite. JavaScript cannot guarantee secure erasure. */
export function wipeBytes(buf: Uint8Array | null | undefined): void {
  if (!buf) return;
  buf.fill(0);
}

export function wipeAll(...bufs: Array<Uint8Array | null | undefined>): void {
  for (const buf of bufs) wipeBytes(buf);
}
